import { TagConfig } from '../../models';

export const normalizeTagLabel = (label?: string) => (label ?? '').trim().toLowerCase();

export const buildTagConfigByIndex = (tagConfigs: TagConfig[]) => {
    const lookup = new Map<string, TagConfig>();
    tagConfigs.forEach(config => lookup.set(String(config.tag_index), config));
    return lookup;
};

export const buildTagConfigByLabel = (tagConfigs: TagConfig[]) => {
    const lookup = new Map<string, TagConfig>();
    tagConfigs.forEach(config => {
        const label = normalizeTagLabel(config.tag_label);
        if (label) {
            lookup.set(label, config);
        }
    });
    return lookup;
};
